import * as Ph from '~/App/Components/Placeholder';
import React from 'react';

export interface LibraryItemProps {
  className?: string;
}

const LibraryItem = ({ className }: LibraryItemProps) => {
  return (
    <div className={className}>
      <div className='max-w-[240px] m-auto'>
        <Ph.Item className='!m-0'>
          <Ph.Row style={{ display: 'block' }}>
            <Ph.Col className='!h-[135px] rounded !mb-3' size={12} big />
            <Ph.Col className='!h-5 !mb-1' size={12} big />
            <Ph.Col className='!h-5 !mb-4' size={12} big />
            <Ph.Col className='!h-7 rounded' size={12} big />
          </Ph.Row>
        </Ph.Item>
      </div>
    </div>
  );
};

export default LibraryItem;
